import { OrderByArgs } from '@/@generated/codegen/API';
import { useQueryParams } from '@/hooks/useQueryParams';

import { parseOrderDirQueryParam } from './parseOrderDirQueryParam';

export const QUERY_PARAM_ORDER_KEY = 'order';
export const QUERY_PARAM_ORDER_DIR_KEY = 'orderDir';

export const useOrderByQueryParam = (prefix: string | null) => {
  const { order, orderDir } = useQueryParams(
    [QUERY_PARAM_ORDER_KEY, QUERY_PARAM_ORDER_DIR_KEY],
    prefix
  );

  const toReturn: OrderByArgs | undefined = order
    ? {
        orderByField: order,
        direction: parseOrderDirQueryParam(orderDir),
      }
    : undefined;
  return toReturn;
};
